

import { hnAPI } from '../../constants/api';
import fetchApi from '../../services/fetch';


const initialState = {
    availablePlans: {},
    selectedPayCondition : {},
    anticipatedPaymentOptions: {},
    selectedAnticipatedPayment: {}
};

export const checkout = {
    state: { ...initialState },
    reducers: {
        setPlans(state, payload) {
            return {
                ...state,
                availablePlans: { ...payload }
            };
        },
        setPayCondition(state , payload){
            return{
                ...state,
                selectedPayCondition : payload
            }
        },
        setAnticipatedPayment(state , payload){
            return{
                ...state,
                anticipatedPaymentOptions : payload
            }
        },
        setSelectedAnticipatedPayment(state , payload){
            return{
                ...state,
                selectedAnticipatedPayment : payload
            }
        }
    },
    effects: dispatch => {
        return {
            async getPaymentConditions({ callback, type, customerIDType, customerID,  ...params }) {
                dispatch.apiStatus.setProcessing(true);
                return fetchApi({
                    method: "POST",
                    url: `${hnAPI.paymentCondition}${customerIDType}/${customerID}`,
                    data: { ...params }
                }).then( response => {
                    this.setPlans(response.data.data.eligibilityDecisions.decisionContent);
                    dispatch.apiStatus.setProcessing(false);
                })
                .catch( error => {
                    dispatch.apiStatus.setRequestFailed({ ...error });
                })
            },
            async anticipatedPayment({ callback, type, salespersonId, consumerId,  ...params }) {
                dispatch.apiStatus.setProcessing(true);
                return fetchApi({
                    method: "POST",
                    url: hnAPI.anticipatedPaymentV2,
                    params:{'salesInfo.salespersonId': salespersonId, consumerId },
                    data: { ...params }
                }).then( response => {
                    dispatch.apiStatus.setProcessing(false);
                    this.setAnticipatedPayment(response?.data)
                    return Promise.resolve({success: true, data: response?.data})
                })
                .catch( error => {
                    dispatch.apiStatus.setRequestFailed({ ...error, message: 'No se encontraron las opciones de pago adelantada' });
                    return Promise.resolve({success: false, error: error})
                })
            }
        };
    }
}

